import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import StopDateFields from '../../../../ReusableFormFields/StopTimeFields'

import { STOP_DATE, STOP_TIME } from '../../../../Multiplatform/LineItemForms/fields'

import useStyles from '../../../../../styles/common/stepForms'

const stepFields = [STOP_TIME, STOP_DATE]

const StopTimeStep = ({ formik, handleStepChange }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <>
      <div className={classes.stepTitle}>{t('When would you like the ad set to end?')}</div>
      <StopDateFields formik={formik} indefiniteOptionDescription={'The ad set will run indefinitely until paused'} />
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default StopTimeStep
